/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * 初期値
 */
let html = document.documentElement;
let splash = document.querySelector(".splash");

const complete = () => {
  html.classList.remove("--loading");
  splash.remove();
}

/**
 * 処理
 */
const setSplash = () => {
  window.addEventListener("DOMContentLoaded", () => {
    let $myWindow = "visited";
    if (window.name.indexOf($myWindow) != -1) {
      html.classList.add("--visited");
      complete();
    } else {
      window.name = $myWindow;
      setTimeout(() => { loadingAnimation(); }, 1000);
    }
  });
};

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __20:対象のクラスを削除
 */
function hintBrowser() {
  let willChangeItem = document.querySelectorAll(".--hintBrowser");
  for (let i = 0; i < willChangeItem.length; i++) {
    willChangeItem[i].classList.remove("--hintBrowser");
  }
}

/**
 * __30:ローディングアニメーション - 共通処理
 */
function loadingAnimation() {
  let splashItem = document.querySelector(".splash-item");
  let mv_img = document.querySelectorAll(".mv__img img");
  let tl = gsap.timeline();

  tl.to([splashItem], { duration: 0.5, y: 0, opacity: 1, ease: "Quart.easeOut", })
    .to([splashItem], { duration: 0.5, yPercent: -50, opacity: 0, ease: "Quart.easeIn", }, "+=0.2")
    .to([splash], { duration: 1.5, opacity: 0, ease: "Quart.easeIn", onComplete: complete, }, "+=0.2")
    .to([mv_img], { duration: 3, scale: 1, ease: "Quart.easeOut", stagger: 0.1 }, "<")
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setSplash
};